import { createTheme } from '@mui/material';

// Custom theme with golf-inspired colors
const theme = createTheme({
  palette: {
    primary: {
      main: '#2e7d32', // Golf green
      light: '#60ad5e',
      dark: '#005005',
    },
    secondary: {
      main: '#1976d2', // Sky blue for water hazards
      light: '#63a4ff',
      dark: '#004ba0',
    },
    background: {
      default: 'rgba(245, 245, 245, 0.8)',
      paper: 'rgba(240, 240, 240, 0.9)',
    },
  },
  typography: {
    h4: {
      fontWeight: 700,
    },
    h5: {
      fontWeight: 600,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          fontWeight: 500,
        },
        deleteIcon: {
          color: '#2e7d32',
          '&:hover': {
            color: '#d32f2f',
          },
        },
      },
    },
  },
});

export default theme;